import { useQuery } from "@apollo/client";

import { Flag } from "@medbillai/utils/flag";

import { errorHandling } from "../../../lib/apollo/utils";
import { useBoolVariation } from "../../../lib/flag";
import {
  getWebAgentEndpointsAllQuery,
  getWebAgentEndpointsP012Query,
} from "../utils/queries";

export function useWebAgentEndpointsQuery() {
  const showP3Endpoints = useBoolVariation(Flag.SHOW_P3_ENDPOINTS, false);

  const query = showP3Endpoints
    ? getWebAgentEndpointsAllQuery
    : getWebAgentEndpointsP012Query;

  return useQuery(query, {
    context: errorHandling("caller"),
  });
}
